<template>
  <div class="process-container" :class="{ mine: mine }">
    <div class="left">{{ percent }}%</div>
    <div class="right">{{ number }}</div>
    <div class="block" :style="{ background: `${ mine ? '#F6CBCB' : '#DDDDDD'}`, width: `${percent}%`}"></div>
  </div>
</template>

<script>
export default {
  name: 'ProcessBar',
  props: {
    percent: {
      type: Number,
      default: 0
    },
    number: {
      type: Number,
      default: 0
    },
    mine: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.process-container{
  border: 1px solid #DDDDDD;
  height: rem(36);
  border-radius: rem(8);
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: rem(16);
  padding-right: rem(16);
  box-sizing: border-box;
  position: relative;
  .left, .right{
    font-size: rem(24);
    color: #666666;
    font-weight: bolder;
    z-index: 101;
  }
  .block{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    transition: width ease-in-out 0.3s;
  }
}
.process-container.mine{
  border: 1px solid #EFA8A8;
  .left,.right{
    color: #D82626;
  }
}
</style>
